module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters,
      "size": "mini"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "项目名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    on: {
      "change": _vm.getDevices
    },
    model: {
      value: (_vm.filters.projectId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "projectId", $$v)
      },
      expression: "filters.projectId"
    }
  }, _vm._l((_vm.projects), function(item) {
    return _c('el-option', {
      key: item.projectId,
      attrs: {
        "label": item.name,
        "value": item.projectId
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "点位名称"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.filters.mn),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mn", $$v)
      },
      expression: "filters.mn"
    }
  }, _vm._l((_vm.devices), function(item) {
    return _c('el-option', {
      key: item.mnCode,
      attrs: {
        "label": item.name,
        "value": item.mnCode
      }
    })
  }), 1)], 1), _vm._v(" "), (_vm.type == 0) ? _c('el-form-item', {
    attrs: {
      "label": "设备编码"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": ""
    },
    model: {
      value: (_vm.filters.mn),
      callback: function($$v) {
        _vm.$set(_vm.filters, "mn", $$v)
      },
      expression: "filters.mn"
    }
  }, _vm._l((_vm.devices), function(item) {
    return _c('el-option', {
      key: item.mnCode,
      attrs: {
        "label": item.mnCode,
        "value": item.mnCode
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "时间范围"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetimerange",
      "unlink-panels": "",
      "picker-options": _vm.pickerOptions,
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期",
      "align": "right"
    },
    model: {
      value: (_vm.filters.time),
      callback: function($$v) {
        _vm.$set(_vm.filters, "time", $$v)
      },
      expression: "filters.time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('form-query-button', {
    on: {
      "select-type": _vm.getDataList
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('vxe-toolbar', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px",
      "width": "100%"
    },
    attrs: {
      "span": 24
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function() {
        return [_c('vxe-button', {
          attrs: {
            "icon": "fa fa-trash"
          },
          on: {
            "click": function($event) {
              return _vm.$refs.xTable.removeCheckboxRow()
            }
          }
        }, [_vm._v("删除选中")]), _vm._v(" "), _c('vxe-button', {
          attrs: {
            "icon": "fa fa-save"
          },
          on: {
            "click": _vm.saveEvent
          }
        }, [_vm._v("提交审核")]), _vm._v(" "), _c('vxe-button', {
          attrs: {
            "icon": "fa fa-mail-reply"
          },
          on: {
            "click": _vm.revertEvent
          }
        }, [_vm._v("界面数据还原")]), _vm._v(" "), _c('vxe-button', {
          attrs: {
            "icon": "fa fa-plus"
          },
          on: {
            "click": function($event) {
              return _vm.showAdd()
            }
          }
        }, [_vm._v("录入数据")])]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('vxe-table', {
    ref: "xTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.dataList,
      "border": "",
      "show-overflow": "",
      "keep-source": "",
      "loading": _vm.listLoading,
      "height": _vm.formHeight,
      "edit-config": {
        trigger: 'click',
        mode: 'cell',
        showStatus: true
      }
    }
  }, [_c('vxe-table-column', {
    attrs: {
      "type": "checkbox",
      "width": "55"
    }
  }), _vm._v(" "), _c('vxe-table-column', {
    attrs: {
      "field": "time",
      "title": "监测时间",
      "fixed": "",
      "sortable": "",
      "min-width": "160"
    }
  }), _vm._v(" "), _vm._l((_vm.facList), function(item) {
    return _c('vxe-table-column', {
      key: item.keyWord,
      attrs: {
        "field": item.keyWord,
        "title": item.title,
        "edit-render": {
          name: '$input',
          props: {
            type: 'number'
          }
        },
        "min-width": "150"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v(_vm._s(scope.row[item.keyWord]))])]
        }
      }], null, true)
    })
  })], 2), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total, sizes, prev, pager, next, jumper",
      "page-size": _vm.pageSize,
      "total": _vm.total,
      "page-sizes": [10, 20, 30, 40, 50],
      "current-page": _vm.page
    },
    on: {
      "current-change": _vm.handleCurrentChange,
      "size-change": _vm.handleSizeChange,
      "update:currentPage": function($event) {
        _vm.page = $event
      },
      "update:current-page": function($event) {
        _vm.page = $event
      }
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "数据录入",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false,
      "append-to-body": true,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('vxe-button', {
    attrs: {
      "icon": "fa fa-plus"
    },
    on: {
      "click": function($event) {
        return _vm.insertEvent()
      }
    }
  }, [_vm._v("新增")]), _vm._v(" "), _c('vxe-button', {
    attrs: {
      "icon": "fa fa-save"
    },
    on: {
      "click": function($event) {
        return _vm.addHandView()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('vxe-button', {
    attrs: {
      "icon": "fa fa-upload"
    },
    on: {
      "click": function($event) {
        return _vm.showUpload()
      }
    }
  }, [_vm._v("识别导入")]), _vm._v(" "), _c('vxe-button', {
    attrs: {
      "icon": "fa fa-download"
    },
    on: {
      "click": function($event) {
        return _vm.exportData()
      }
    }
  }, [_vm._v("模板下载")]), _vm._v(" "), _c('vxe-table', {
    ref: "addTable",
    staticStyle: {
      "width": "100%",
      "margin-top": "10px"
    },
    attrs: {
      "data": _vm.dataAddList,
      "border": "",
      "show-overflow": "",
      "keep-source": "",
      "edit-config": {
        trigger: 'click',
        mode: 'cell'
      }
    }
  }, [_c('vxe-table-column', {
    attrs: {
      "type": "checkbox",
      "width": "55"
    }
  }), _vm._v(" "), _c('vxe-table-column', {
    attrs: {
      "field": "time",
      "title": "监测时间",
      "edit-render": {
        name: '$input',
        props: {
          type: 'datetime',
          placeholder: '请选择时间'
        }
      },
      "min-width": "160"
    }
  }), _vm._v(" "), _vm._l((_vm.facList), function(item) {
    return _c('vxe-table-column', {
      key: item.keyWord,
      attrs: {
        "field": item.keyWord,
        "title": item.title,
        "edit-render": {
          name: '$input',
          props: {
            type: 'number'
          }
        },
        "min-width": "150"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('span', [_vm._v(_vm._s(scope.row[item.keyWord]))])]
        }
      }], null, true)
    })
  })], 2)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "识别导入",
      "visible": _vm.uploadVisible,
      "close-on-click-modal": false,
      "append-to-body": true,
      "width": "80%"
    },
    on: {
      "update:visible": function($event) {
        _vm.uploadVisible = $event
      }
    }
  }, [_c('el-upload', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.upoloadLoading),
      expression: "upoloadLoading"
    }],
    ref: "upload",
    staticClass: "upload-demo",
    attrs: {
      "action": "#",
      "name": "file",
      "on-change": _vm.change,
      "before-upload": _vm.progressing,
      "element-loading-text": "文件上传中",
      "element-loading-spinner": "el-icon-loading",
      "accept": ".xls, .xlsx",
      "multiple": false,
      "file-list": _vm.fileList,
      "auto-upload": false,
      "drag": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("提示：仅允许导入“xls”或“xlsx”格式文件！")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("提示：请先下载模板再上传，格式不允许修改！")])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancleSet.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.uploadHandView.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-2319ed64"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/uploadNoise/DataManagement.vue
// module id = 1885
// module chunks = 1